export default function Footer() {
  return (
    <footer className="border-t border-white/10 mt-20 bg-black/40" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 py-12 grid md:grid-cols-3 gap-8">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <img src="/logo-er.png" alt="Escape Room Bengaluru" className="h-9 w-auto" />
            <span className="font-display font-extrabold text-lg">Escape Room Express</span>
          </div>
          <p className="text-sm text-slate-400 max-w-xs">The escape room that drives to you. Cinematic 45-minute mysteries, parked at your tech park.</p>
        </div>
        <div>
          <div className="font-display font-bold mb-3">Explore</div>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><a href="/games" className="hover:text-[#F9CF04]">Games</a></li>
            <li><a href="/leaderboard" className="hover:text-[#F9CF04]">Leaderboard</a></li>
            <li><a href="/challenge" className="hover:text-[#F9CF04]">Challenge a team</a></li>
          </ul>
        </div>
        <div>
          <div className="font-display font-bold mb-3">Get in touch</div>
          <p className="text-sm text-slate-400">Bengaluru · On-site at tech parks</p>
          <p className="text-sm text-slate-400 mt-1">hello@escaperoomexpress.in</p>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} Escape Room Express · Adventures on Wheels
      </div>
    </footer>
  );
}
